import cx from 'classnames'
import { observer } from 'mobx-react-lite'
import { useRef } from 'react'

import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useRootStore } from 'stores/RootStore'

import Styles from './SidebarResizeHandle.module.scss'
import { useSidebarResize } from 'blaze-components/WorkspaceDashboardSidebar/hooks/useSidebarResize'

const SidebarResizeHandle = observer(() => {
  const resizeHandleRef = useRef<HTMLDivElement>(null)
  const { handleSidebarResizeStart } = useSidebarResize(resizeHandleRef)
  const sidebarStore = useRootStore().leftSidebarStore
  const { isMobile } = useResponsiveDesign()

  if (isMobile) return null

  return (
    <div
      className={cx(Styles.sidebarResizeHandleContainer)}
      style={{
        transform: `translateX(${sidebarStore.sidebarWidth - 8}px)`,
      }}
      onMouseEnter={() => sidebarStore.setIsHovered(false)}
      onMouseLeave={() => sidebarStore.setIsHovered(true)}
    >
      <div
        ref={resizeHandleRef}
        className={cx(Styles.sidebarResizeHandle, {
          [Styles.isResizing]: sidebarStore.isResizing,
        })}
        onMouseDown={(e) => {
          e.preventDefault()
          handleSidebarResizeStart(e)
        }}
      />
    </div>
  )
})

export { SidebarResizeHandle }
